import {
  AppBar,
  Button,
  Dialog,
  IconButton,
  Slide,
  Toolbar,
  Typography,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import { Masonry } from "@mui/lab";
import React, { useEffect, useState } from "react";
import { getMediaList } from "../services/media.service";
import Constants from "../data/Constants";
import Utils from "../utils";
import Skeleton from "react-loading-skeleton";
import Toast from "./Toast";
import MediaCard from "./MediaCard";
import { GrUpload } from "react-icons/gr";
import MediaUploadDialog from "./MediaUploadDialog";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function MediaManager(props) {
  const { open, onClose, onSelect, type } = props;
  const [data, setData] = useState(false);
  const [progress, setProgress] = useState(false);
  const [toast, setToast] = useState({ error: false, success: false });
  const [updateView, setUpdateView] = useState(0);
  const [mediaUploadDialogState, setMediaUploadDialogState] = useState({
    open: false,
  });

  const forceUpdateView = () => {
    let i = updateView + 1;
    setUpdateView(i);
  };

  useEffect(() => {
    setProgress(true);

    async function api() {
      try {
        const filters = { sort: "desc" };

        if (type) {
          filters.type = type.split(",");
        }

        const data = await getMediaList(filters);
        if (data) {
          setData(data);
          setProgress(false);
        } else {
          // error

          setProgress(false);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error

        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }
    api();
  }, [updateView]);

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <GridCloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Media Manager
          </Typography>
          <div className=" z-20">
            <IconButton
              onClick={() => {
                setMediaUploadDialogState({
                  ...mediaUploadDialogState,
                  open: true,
                });
              }}
            >
              <GrUpload className="text-white" />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>

      <div className="p-2">
        {type && (
          <h1 className="mx-5 p-4">
            File Type: <span className="font-bold ">{type}</span>
          </h1>
        )}

        <div className="flex gap-2 flex-wrap justify-center">
          {data &&
            data.map((media, index) => {
              if (type) {
                if (!type.includes(media.type)) {
                  return;
                }
              }

              return (
                <MediaCard
                  key={index}
                  media={media}
                  onClick={() => {
                    onSelect(media);
                    onClose(true);
                  }}
                />
              );
            })}

          {progress && (
            <React.Fragment>
              <Skeleton className="m-2 w-64 h-40" />
              <Skeleton className="m-2 w-64 h-40" />
              <Skeleton className="m-2 w-64 h-40" />
              <Skeleton className="m-2 w-64 h-40" />
              <Skeleton className="m-2 w-64 h-40" />
              <Skeleton className="m-2 w-64 h-40" />
              <Skeleton className="m-2 w-64 h-40" />
              <Skeleton className="m-2 w-64 h-40" />
              <Skeleton className="m-2 w-64 h-40" />
              <Skeleton className="m-2 w-64 h-40" />
              <Skeleton className="m-2 w-64 h-40" />
              <Skeleton className="m-2 w-64 h-40" />
            </React.Fragment>
          )}

          <Toast
            success={toast.success}
            error={toast.error}
            message={toast.message}
            onClose={() => {
              setToast({ ...toast, error: false, success: false });
            }}
          />
        </div>
      </div>
      <MediaUploadDialog
        open={mediaUploadDialogState.open}
        onCreate={() => {
          forceUpdateView();
        }}
        onClose={() =>
          setMediaUploadDialogState({ ...mediaUploadDialogState, open: false })
        }
        onError={(error) => {
          console.log(error);
        }}
      />
    </Dialog>
  );
}

export default MediaManager;
